import { Inject, Pipe, PipeTransform } from "@angular/core";
import { IndexDataPointType } from '@core/data/types/Reports/report-indexes';
import { Library } from '@library';
import { LIBRARY } from '../library';

@Pipe({
    name: 'describeIndexDataPoint'
})
export class DescribeIndexDataPoint implements PipeTransform{
    constructor(
        @Inject(LIBRARY) private _library: Library,
    ) {}

    transform(id: string, type: IndexDataPointType) {
        let label = id;

        if (type === IndexDataPointType.CHARACTERISTIC) label = this._library.chars.get(id)?.label;
        if (type === IndexDataPointType.INDEX) label = this._library.indexes.get(id)?.label;

        return label;
    }
}